export default __webpack_public_path__ + "static/media/FAQ.e6938097.png";